<!-- vertical layout -->
@if (isVerticalLayoutRequested()) {
  <app-vertical [breadcrumbs]="breadcrumbs"></app-vertical>
}
<!-- <img *ngIf="validatorsService.loadingPage()" class="loading-page img-fluid" src="../../assets/img/gifs/loading-none-back.gif" alt=""> -->
<!-- <div *ngIf="validatorsService.loadingPage()" class="spinner-wrapper">
<div class="spinner"></div>
</div> -->

<!-- horizontal layout -->
@if (isHorizontalLayoutRequested()) {
  <app-horizontal [breadcrumbs]="breadcrumbs"></app-horizontal>
}

<app-pwa-install></app-pwa-install>
